/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import { classNames } from '@/shared/lib/classNames/classNames';
import { Dropdown } from '@/shared/ui/DropDown/DropDown';
import { aboutCompany, corporativeClients, DropDownData, dropdownData, dropdownDataMobile } from './menuItems/dropdownOptions';
import Shock from '@/shared/assets/icons/shock.svg';
import cls from './SubMenu.module.scss';

interface MenuProps {
    className?: string;
    styleType?: 'onMenu' | 'onSideMenu';
}

export const SubMenu: React.FC<MenuProps> = ({
    className,
    styleType = 'onMenu', // Provide a default value
}) => {
    const handleSelect = (value: any) => {
        console.log('Selected Value:', value);
    };

    const radioData = [
        { label: 'Частным клиентам', value: 'Частным клиентам' },
        { label: 'Корпоративным клиентам', value: 'Корпоративным клиентам' },
        { label: 'О компании', value: 'О компании' },
    ];

    const link = {
        placeholder: 'Заявить о страховом случае',
        logo: Shock,
        url: 'https://sberbank-insurance.ru/online-helper?utm_medium=our_traffic',
    };

    const [radioBtnValue, setRadioBtnValue] = useState<string>('Частным клиентам');
    const [data, setData] = useState<DropDownData>();

    useEffect(() => {
        if (styleType === 'onMenu') {
            setData(dropdownData);
        }
        if (styleType === 'onSideMenu' && radioBtnValue === 'Частным клиентам') {
            setData(dropdownDataMobile);
        }
        if (styleType === 'onSideMenu' && radioBtnValue === 'Корпоративным клиентам') {
            setData(corporativeClients);
        }
        if (styleType === 'onSideMenu' && radioBtnValue === 'О компании') {
            setData(aboutCompany);
        }
    }, [styleType, radioBtnValue]);

    return (
        <nav className={classNames(cls.Menu, {}, [className, cls[styleType]])}>
            <div className={cls.navBtns}>
                {radioData.map((data) => (
                    <div className={cls.item} key={data.value}>
                        <input
                            id={data.value}
                            type="radio"
                            value={data.value}
                            className={`${cls.input} visually-hidden`}
                            checked={data.value === radioBtnValue}
                            onChange={(e) => {
                                setRadioBtnValue(e.currentTarget.value);
                            }}
                        />
                        <label onClick={() => setRadioBtnValue(data.value)} className={cls.name} htmlFor={data.value}>
                            <span className={cls.text}>{data.label}</span>
                        </label>
                    </div>
                ))}
            </div>
            <ul className={cls.list}>
                {styleType === 'onSideMenu' && radioBtnValue === 'Частным клиентам' && (
                    <div className={classNames(cls.dropdown)}>
                        <a href={link.url} className={cls.control}>
                            <img
                                src={link.logo}
                                alt="logo"
                                style={{ marginRight: '12px', verticalAlign: 'middle', width: '52px', height: '56px' }}
                            />

                            <p>{link.placeholder || 'Select an option'}</p>
                        </a>
                    </div>
                )}

                {data?.map((data, index) => (
                    <li key={`${data.placeholder + index}`} className={cls.item}>
                        <Dropdown
                            options={data.options}
                            onSelect={handleSelect}
                            placeholder={data.placeholder}
                            logo={data.logo}
                            styleType={styleType}
                        />
                    </li>
                ))}
            </ul>
        </nav>
    );
};
